/**
 * Blog / IT single: table-of-contents smooth scroll + scroll-spy.
 * Used by single-post.php and single-information_tech.php.
 */
document.addEventListener('DOMContentLoaded', function () {
    var tocLinks = document.querySelectorAll('.post-toc .toc-list a[href^="#"], .post-toc-offcanvas .toc-list a[href^="#"]');
    if (!tocLinks.length) return;

    var headings = [];
    tocLinks.forEach(function (link) {
        var id = decodeURIComponent(link.getAttribute('href').substring(1));
        var el = document.getElementById(id);
        if (el && headings.indexOf(el) === -1) {
            headings.push(el);
        }
    });

    if (!headings.length) return;

    function getHeaderOffset() {
        var header = document.querySelector('.site-header');
        return header ? header.offsetHeight + 25 : 120;
    }

    function setActiveLink(activeId) {
        tocLinks.forEach(function (link) {
            var linkId = decodeURIComponent(link.getAttribute('href').substring(1));
            link.classList.toggle('active', linkId === activeId);
        });
    }

    // Smooth scroll on click with header offset
    tocLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            var href = this.getAttribute('href');
            if (!href || href === '#') return;
            var targetId = decodeURIComponent(href.substring(1));
            var targetEl = document.getElementById(targetId);
            if (!targetEl) return;

            e.preventDefault();
            var offsetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });

            if (history.pushState) {
                history.pushState(null, null, '#' + targetId);
            }

            // Close offcanvas if open on mobile
            var offcanvasEl = document.getElementById('tocOffcanvas');
            if (offcanvasEl && typeof bootstrap !== 'undefined' && bootstrap.Offcanvas) {
                var bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);
                if (bsOffcanvas) bsOffcanvas.hide();
            }

            setActiveLink(targetId);
        });
    });

    // ScrollSpy to dynamically highlight active heading in TOC
    var isTicking = false;
    function onScroll() {
        if (isTicking) return;
        window.requestAnimationFrame(function () {
            var headerOffset = getHeaderOffset() + 35;
            var currentActive = null;

            for (var i = 0; i < headings.length; i++) {
                if (headings[i].getBoundingClientRect().top <= headerOffset) {
                    currentActive = headings[i].id;
                } else {
                    break;
                }
            }

            // If at top of post, highlight first item
            if (!currentActive && headings[0].getBoundingClientRect().top <= window.innerHeight * 0.45) {
                currentActive = headings[0].id;
            }

            if (currentActive) {
                setActiveLink(currentActive);
            }

            isTicking = false;
        });
        isTicking = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setTimeout(onScroll, 150);
});
